import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SessionService } from '@app/core/session/session.service';
var BurgerMenuComponent = /** @class */ (function () {
    function BurgerMenuComponent(sessionService) {
        this.sessionService = sessionService;
        this.fControl = new FormControl();
        this.isShowiServices = false;
    }
    BurgerMenuComponent.prototype.ngOnInit = function () {
        this.menuOpened = false;
        this.jwt = this.sessionService.retrieveToken();
    };
    BurgerMenuComponent.prototype.openMenu = function () {
        this.menuOpened = true;
    };
    BurgerMenuComponent.prototype.onCloseMenu = function (closeEvent) {
        this.menuOpened = !closeEvent;
    };
    BurgerMenuComponent.prototype.onSubmit = function (submitted) {
        if (submitted) {
            this.onCloseMenu(submitted);
        }
    };
    return BurgerMenuComponent;
}());
export { BurgerMenuComponent };
